import { useEffect, useRef } from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import './OCheck.scss';

interface IOCheckProps {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  variant?: 'primary';
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;

  indeterminate?: boolean;
  ariaLabel?: string;
}

const OCheck: React.FC<IOCheckProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  variant = 'primary',
  className,
  onClick,
  indeterminate = false,
  ariaLabel,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);

  return (
    <div
      className={`checkbox__container ${variant} ${className ?? ''}`}
      data-indeterminate={indeterminate ? 'true' : 'false'}
    >
      <Checkbox
        checked={indeterminate ? false : checked}
        onChange={(e: CheckboxChangeEvent) => onChange(e.checked ?? false)}
        disabled={disabled}
        onClick={onClick}
        inputRef={inputRef}
        role="checkbox"
        aria-checked={indeterminate ? 'mixed' : checked ? 'true' : 'false'}
        aria-label={ariaLabel ?? label}
      />
      {label && <label>{label}</label>}
    </div>
  );
};

export default OCheck;
